module.exports = __webpack_public_path__ + "images/mywort/default-post-picture.png";


//////////////////
// WEBPACK FOOTER
// ./images/mywort/default-post-picture.png
// module id = 1525
// module chunks = 93